import { useState } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { LockClosedIcon, XMarkIcon, PlusIcon } from '@heroicons/react/24/outline'

import ModalContainer from 'components/ModalContainer'
import { Button, Card, Input, Table } from 'components/gsys-ui'
import { getToken } from 'util/haxios'
import { getApirAddr, getCompanyInfo } from 'util/api'

const AddCompanyModal = NiceModal.create(({ refreshList }) => {
  const modal = useModal()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setLoading] = useState(false)

  const handleCheckCredentials = async () => {
    setLoading(true)
    const tokenRes = await getToken(username, password, false, true)
    if (!tokenRes) return console.log('bad credentials')
    const token = tokenRes.data.token
    const cinfoRes = await getCompanyInfo(token)
    if (!cinfoRes) return console.log('bad token')
    const apirRes = await getApirAddr(cinfoRes.CompanyID)
    const companiesLs = window.localStorage.getItem('companies')
    const companies = companiesLs ? JSON.parse(companiesLs) : []

    window.localStorage.setItem('companies', JSON.stringify([
      ...companies,
      {
        username,
        password,
        apir: apirRes.CompanyDomain,
        companyId: cinfoRes.CompanyID,
        companyName: cinfoRes.CompanyName,
        logoUrl: `https://${apirRes.CompanyDomain}/api/public/images/logo.jpg`
      }
    ]))

    refreshList()
    modal.remove()
  }

  return (
    <ModalContainer>
      <Card className="!w-[400px]">
        <Card.Title Icon={PlusIcon}>
          Add company
        </Card.Title>
        <Card.Body>
          <div className="mt-2 space-y-2">
            <Input label="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
            <Input label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <div className="flex justify-end mt-2 space-x-2">
            <Button Icon={XMarkIcon} variant="white" onClick={modal.remove}>Close</Button>
            <Button Icon={LockClosedIcon} variant="blue" onClick={handleCheckCredentials} loading={isLoading}>Check</Button>
          </div>
        </Card.Body>
      </Card>
    </ModalContainer>
  )
})

export default AddCompanyModal